import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-behind-square-3, copy 3, layers, pages"><path d="M8.75 15.25V21.25H21.25V8.75H15.25M15.25 15.25H2.75V2.75H15.25V15.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareBehindSquare3;
